// Plants tab: species used in the plan with counts. Click selects every
// element carrying the species (within the layer filter); the ↗ opens the
// plant profile; hovering shows the species flyout.

import { esc, profileLink } from './html';
import { activeLayerFilter, matchesLayer, layerFilterHtml } from './filters';

// Elements the Plants tab counts/selects from: those on the filtered layer.
export function plantElements(state, layer = '') {
  const lf = activeLayerFilter(state, layer);
  return state.elements.filter((el) => matchesLayer(el, lf, state));
}

export function plantsPanelHtml(state, { filter = '', layer = '' } = {}) {
  const countIn = (els) => {
    const counts = new Map();
    for (const el of els) for (const sid of (el.speciesIds || [])) counts.set(sid, (counts.get(sid) || 0) + 1);
    return counts;
  };
  const total = countIn(state.elements).size;
  const lf = activeLayerFilter(state, layer);
  const counts = countIn(plantElements(state, lf));
  const q = filter.trim().toLowerCase();
  const entries = [...counts.entries()].filter(([sid]) => {
    if (!q) return true;
    const sp = state.species[sid] || {};
    return `${sp.name || ''} ${sp.scientific_name || ''} ${sp.parent_name || ''}`.toLowerCase().includes(q);
  });
  const rows = entries.map(([sid, n]) => {
    const sp = state.species[sid];
    const name = sp?.name || `Plant #${sid}`;
    const thumb = sp?.thumb ? `<img class="pl2-plant-thumb" src="${esc(sp.thumb)}" alt="">` : '<span class="pl2-plant-thumb"></span>';
    return `<div class="pl2-row" data-pl2="plant-select" data-id="${sid}" data-species-info="${esc(sid)}">
      ${thumb}<span class="pl2-row__name">${esc(name)}</span><span class="pl2-muted">${n}</span>${profileLink(sp?.link)}
    </div>`;
  }).join('');
  const filtered = q || lf;
  const count = filtered ? `${entries.length} of ${total}` : total;
  const empty = filtered ? 'No plants match that filter.' : 'No plants yet.';
  const filters = total
    ? `<input class="pl2-input pl2-filter" type="search" placeholder="Filter plants…" data-pl2="filter-plants" value="${esc(filter)}">
       ${layerFilterHtml(state, 'filter-plants-layer', lf)}`
    : '';
  return `
    <h3 class="pl2-section-title">Plants in plan (${count})</h3>
    ${filters}
    ${rows || `<p class="pl2-muted">${empty}</p>`}`;
}
